import { render, staticRenderFns } from "./Mold.vue?vue&type=template&id=ffd1417c&"
import script from "./Mold.vue?vue&type=script&lang=js&"
export * from "./Mold.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports